import script from "./PendingTransfertContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingTransfertContent.vue?vue&type=script&setup=true&lang=ts"

import "./PendingTransfertContent.vue?vue&type=style&index=0&id=5c791a49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c791a49"]])

export default __exports__